import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Model } from "vue-property-decorator";
import { Input } from "@h3/antd-vue";
let H3Textarea = class H3Textarea extends Vue {
    constructor() {
        super(...arguments);
        this.isFocus = false;
    }
    get length() {
        return this.countLengthOf(this.value);
    }
    onChange(evt) {
        const val = evt.target.value;
        const length = this.countLengthOf(val);
        if (length <= this.maxLength) {
            this.$emit("change", val);
        }
    }
    // countLengthOf(s: string) {
    //   if (!s) {
    //     return 0;
    //   }
    //   const reg = /[\u4e00-\u9fa5]+/;
    //   let result: RegExpExecArray | null;
    //   let len = 0;
    //   while (((result = reg.exec(s)), result !== null)) {
    //     len += result[0].length * 2;
    //     s = s.replace(reg, "");
    //   }
    //   len += s.length;
    //   return len;
    // }
    countLengthOf(s) {
        if (!s) {
            return 0;
        }
        return s.length;
    }
    focus() {
        this.isFocus = true;
    }
    blur() {
        this.isFocus = false;
    }
};
tslib_1.__decorate([
    Prop({
        default: 2000
    })
], H3Textarea.prototype, "maxLength", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3Textarea.prototype, "disabled", void 0);
tslib_1.__decorate([
    Model("change")
], H3Textarea.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: ""
    })
], H3Textarea.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Textarea.prototype, "autosize", void 0);
H3Textarea = tslib_1.__decorate([
    Component({
        name: "h3-textarea",
        components: {
            ATextarea: Input.TextArea
        }
    })
], H3Textarea);
export default H3Textarea;
